/**
 * Default variant served by LaunchDarkly.
 */
export const DEFAULT_QUALIFICATION_CATEGORIES = {
  popular: [
    "CNA",
    "LVN",
    "RN",
    "Dental Hygienist",
    "Dental Assistant",
    "Substitute Teacher",
    "Teacher Assistant",
    "Lead Teacher",
  ],
};

export const ALL_QUALIFICATIONS_CATEGORY = "all";
